import { ApiError } from "@/lib/api/client";

/**
 * The newest record a 409 carries beside its message, or null for any other
 * failure. Every guarded save answers a stale write with
 * `{message, current}` in `detail`; the people route predates that and names
 * the record `person`, hence the key.
 */
export function currentOnConflict<T>(error: unknown, key = "current"): T | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null;
  const detail = error.detail;
  if (typeof detail !== "object" || detail === null) return null;
  const current = (detail as Record<string, unknown>)[key];
  return typeof current === "object" && current !== null ? (current as T) : null;
}

/** R4: attach the read token explicitly; old callers remain unchanged. */
export function withVersion<T extends object>(body: T, version: string): T & { expected_updated_at: string } {
  if (!version.trim() || !Number.isFinite(Date.parse(version))) throw new TypeError("Read a version before saving");
  return { ...body, expected_updated_at: version };
}
